/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CrossrefResultCountVariant {
  control = 'control',
  variation = 'variation',
}

export enum DataSource {
  JSTOR = 'JSTOR',
  bing = 'bing',
  crossref = 'crossref',
  worldcat = 'worldcat',
}

export enum Order {
  asc = 'asc',
  desc = 'desc',
}

export enum OrderBy {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt',
}

export enum PapersOrderBy {
  createdAt = 'createdAt',
  filename = 'filename',
  updatedAt = 'updatedAt',
}

export enum PubSuffix {
  pubdatabase = 'pubdatabase',
  pubonline = 'pubonline',
}

export enum PubTypeEnum {
  pubfederal = 'pubfederal',
  pubfilm = 'pubfilm',
  pubjournal = 'pubjournal',
  pubmagazine = 'pubmagazine',
  pubnewspaper = 'pubnewspaper',
  pubnone = 'pubnone',
  pubnonperiodical = 'pubnonperiodical',
  pubonline = 'pubonline',
  pubother = 'pubother',
}

export enum SourceEnum {
  bible = 'bible',
  book = 'book',
  chapter = 'chapter',
  conference = 'conference',
  congress = 'congress',
  dictionary = 'dictionary',
  dissertation = 'dissertation',
  'dissertation-abstract' = 'dissertationabstract',
  encyclopedia = 'encyclopedia',
  'federal-bill' = 'fedbill',
  film = 'film',
  govt = 'govt',
  introduction = 'introduction',
  journal = 'journal',
  magazine = 'magazine',
  map = 'map',
  multivolume = 'multivolume',
  'musical-recording' = 'musicalrecording',
  newspaper = 'newspaper',
  software = 'software',
  thesis = 'thesis',
  tvr = 'tvr',
  website = 'website',
}

export interface ContributorInput {
  first?: string | null
  middle?: string | null
  last?: string | null
  function?: string | null
  data?: any | null
}

export interface CreateCitationInput {
  pubType?: string | null
  sourceType?: string | null
  annotation?: string | null
  data: any
  contributors?: ContributorInput[] | null
}

//==============================================================
// END Enums and Input Objects
//==============================================================
